import React from "react";
import { Row, Col } from "react-bootstrap";
import { Field } from "redux-form";
import Checkbox from "../../../../components/common/checkbox/Checkbox";

class ReferenceSkills extends React.Component {
  render() {
    const { skills } = this.props;

    if (!skills) return null;

    return skills.map((el, index) => (
      <Row>
        <Col md={6} xs={6}>
          <Field
            name={`skills[${el.id}]`}
            text={el.name}
            component={Checkbox}
            isBig={true}
            key={index}
            // validate={required} //checkbox
          />
        </Col>
      </Row>
    ));
  }
}

export default ReferenceSkills;



// WEBPACK FOOTER //
// ./src/routes/admin/reference/components/ReferenceSkills.js